import Axios from "axios";
import {
    SET_CMS_FOLDER_LIST,
    UNSET_CMS_FOLDER_LIST,
} from "@/store/mutation-types";

import { 
    getCmsFolders,
} from "@/store/api";

const state = {
    getCmsFoldersList: [],
};

const getters = {
    getCmsFoldersList(state) {
        return state.getCmsFoldersList;
    },
};

const mutations = {
    [SET_CMS_FOLDER_LIST](state, data) {
        state.getCmsFoldersList = data;
    },
    [UNSET_CMS_FOLDER_LIST](state) {
        state.getCmsFoldersList = [];
    },
};

const actions = {
    getCmsFoldersList({ commit }, data) {
        return new Promise((resolve, reject) => {
            // commit("SET_LOADING", {color: "primary"});
            Axios.get(getCmsFolders, { params: data})
                .then(function (response) {
                    commit('SET_CMS_FOLDER_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_CMS_FOLDER_LIST')
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING")
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
